import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import DistanceFilter from "./basicFilterComponents/DistanceFilter";
import AgeFilter from "./basicFilterComponents/AgeFilter";
import GlobalStyles from "../../../../globalStyles/globalStyles";
// import OptionsFilter from "../OptionsFilter";
import { Colors } from "../../../../globalStyles/ColorConfig";
import { styles } from "./basicFilterStyles";
import FilterItemBasic from "./basicFilterComponents/FilterItemBasic";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface BasicFiltersProps {
  onPress: (
    label: string,
    value: string,
    filters: any,
    setFilters: any,
    component?: any,
    name?: any
  ) => void;
  filters: any;
  setFilters: any;
  toggleModal: () => void;
}

export default function BasicFilters({
  onPress,
  filters,
  setFilters,
  toggleModal,
}: BasicFiltersProps) {
  const filtersData = [
    {
      label: "I’m interested in",
      multiselect: true,
      value:
        filters?.basicFilters?.gender &&
        filters?.basicFilters?.gender.length > 1
          ? filters?.basicFilters?.gender?.join(", ")
          : filters?.basicFilters?.gender,
      name: "gender",
      type: "optionFilter",
      options: [
        {
          label: "Male",
          active: false,
        },
        {
          label: "Female",
          active: false,
        },
        {
          label: "Other",
          active: false,
        },
      ],
    },
    {
      label: "Age Range",
      name: "ageRange",
      value:
        `${filters?.basicFilters.ageRange.min}-${filters?.basicFilters.ageRange.max}` ||
        "Select",
      component: <AgeFilter filters={filters} setFilters={setFilters} />,
    },
    {
      label: "Maximum Distance",
      value:
        `${filters?.basicFilters.minDistance}-${filters?.basicFilters.maxDistance}` ||
        "Select",
      name: "maxDistance",
      component: <DistanceFilter filters={filters} setFilters={setFilters} />,
    },
    {
      label: "Language they know",
      multiselect: true,
      type: "optionFilter",
      name: "language",
      options: [
        { label: "English", active: false },
        { label: "Spanish", active: false },
        { label: "French", active: false },
        { label: "German", active: false },
        { label: "Italian", active: false },
        { label: "Portuguese", active: false },
        { label: "Dutch", active: false },
        { label: "Russian", active: false },
        { label: "Chinese (Mandarin)", active: false },
        { label: "Japanese", active: false },
        { label: "Korean", active: false },
        { label: "Arabic", active: false },
        { label: "Turkish", active: false },
        { label: "Hindi", active: false },
        { label: "Urdu", active: false },
        { label: "Bengali", active: false },
        { label: "Punjabi", active: false },
        { label: "Swahili", active: false },
        { label: "Tagalog", active: false },
        { label: "Vietnamese", active: false },
        { label: "Thai", active: false },
        { label: "Indonesian", active: false },
      ],
      value:
        filters?.basicFilters?.language.length > 1
          ? filters?.basicFilters?.language?.join(", ")
          : filters?.basicFilters?.language.length || "Select",
    },
  ];

  const handlePress = (
    label: string,
    value: string,
    component: any,
    name: any,
    filters: any,
    setFilters: any
  ) => {
    onPress(
      label,
      value,
      React.cloneElement(component, { filters, setFilters }),
      name,
      filters,
      setFilters
    );
  };

  const handleApplyFilters = () => {
    setFilters((prevFilters: any) => {
      const updatedFilters = {
        ...prevFilters,
        basicFilters: { ...prevFilters.basicFilters },
      };

      // Save the updated state to AsyncStorage
      AsyncStorage.setItem("filters", JSON.stringify(filters));

      return updatedFilters;
    });

    toggleModal();
  };

  return (
    <View
      style={{
        flex: 1,
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <View>
        {filtersData.map((filter, index) => (
          <FilterItemBasic
            filter={filter}
            key={index}
            label={filter.label}
            value={filter.value}
            type={filter.type}
            component={filter.component}
            name={filter.name}
            filters={filters}
            setFilters={setFilters}
            handlePress={handlePress}
            advanced={false}
            multiselect={filter.multiselect}
          />
        ))}
      </View>
      <View
        style={{
          paddingHorizontal: 16,
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        <TouchableOpacity
          style={[
            GlobalStyles.primaryButton,
            {
              backgroundColor: Colors.darkGreen,
              width: "100%",
              marginHorizontal: "auto",
            },
          ]}
          onPress={handleApplyFilters}
        >
          <Text
            style={[
              GlobalStyles.ctaText,
              {
                color: "#FDFBF9",
              },
            ]}
          >
            Apply Filters
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}
